import React, { useState, createRef } from 'react';
import classNames from 'classnames';

export default props => {
  const videoRef = createRef();
  const [ mediaPaused, setMediaPaused ] = useState(false);

  const _handlePlayPauseClick = e => {
    if(videoRef.current.paused){
      videoRef.current.play();
      setMediaPaused(false);
    }else{
      videoRef.current.pause();
      setMediaPaused(true);
    }
  }

  return (
    <div className="cart__media">
      <video
        className={classNames({
          'paused': mediaPaused
        })}
        ref={videoRef}
        type={'video/mp4'}
        src={'https://platform.akkurat.tv/wp-content/uploads/2019/12/Floyd_Bowling_60_small.mp4'}
        playsInline
        autoPlay
        loop
        muted
        onClick={e => _handlePlayPauseClick(e)}
        />
    </div>
  )
}
